import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyFieldSelectProps, FormlySelectModule } from '@ngx-formly/core/select';
import { RadioButton } from '@openng/optimus-ui/radiobutton';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface RadioProps extends FieldWrapperProps, FormlyFieldSelectProps {
  isHorizontal?: boolean;
  variant?: 'outlined' | 'filled';
  size?: 'small' | 'large';
}

export interface RadioFieldConfig extends FormlyFieldConfig<RadioProps> {
  type?: 'radio' | Type<RadioTypeComponent>;
}

@Component({
  selector: 'lib-formly-radio-type',
  templateUrl: './radio-type.component.html',
  styleUrl: './radio-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslocoDirective,
    ReactiveFormsModule,
    FormlyModule,
    AsyncPipe,
    FormlySelectModule,
    RadioButton,
    NgClass
  ]
})
export class RadioTypeComponent extends FieldType<FieldTypeConfig<RadioProps>> {}
